import config from '../../config';
import Transition from '../Transition';
// let ACHIEVEMENT_DATA = require('../../achievements');
import { numberMap } from '../../utils';
// import Clouds from '../Clouds';
import Elevator from './Elevator';
import Barriers from './Barriers';
import Hero from './hero';
import Knight from './Knight';
import Health from './Health';
import PowerMeter from './PowerMeter';
import BurstParticle from './BurstParticle';
import MPUtils from '../../mp/MPUtils';

let FPS;

let apiManager;
let dataManager;
let soundManager;

const FLOOR_HEIGHT = 1024;
const BARRIER_COUNT = 4;
const BARRIER_COUNT_INCREASE = 1;
const START_SPEED = 2.5;
const SPEED_INCREASE = 0.25;
const MAX_SPEED = 10;
const SPECIAL_SPEED = 15;
const SPECIAL_BARRIER_COUNT = 10;
const POINTS_PER_BARRIER = 10;
const POINTS_PER_FLOOR = 100;

const METER_BARRIER_FILL = 5;
// const METER_BARRIER_FILL = 20; // for fast special in dev only
const METER_BARRIER_FILL_MIN = 1;
const METER_BARRIER_FILL_DECREASE = 0.5;
const METER_BARRIER_DRAIN = 25;

// possibly get rid of intro state and just use transition state
const INTRO_STATE = 'INTRO_STATE';
const GAME_STATE = 'GAME_STATE';
const SPECIAL_STATE = 'SPECIAL_STATE';
const TRANSITION_STATE = 'TRANSITION_STATE';

class Play extends Phaser.Scene {
  init () {
    // console.log('Play.init');
    let g = this;

    apiManager = g.sys.game.apiManager;
    dataManager = g.sys.game.dataManager;
    soundManager = g.scene.get('SoundManager');

    dataManager.setSessionItem(config.BASE_SCENE, 'Play');

    dataManager.clearActiveScore();

    FPS = 1000 / g.sys.game.loop.targetFps;

    g.levelData = {
      scrollPosition: 0, // global elevator position tracking
      floor: 1, // i.e wave or level
      perfectFloorCount: 0,
      currentFloorPerfection: true,
      htpWaiting: true,
      specialActive: false,
      specialCompletedCount: 0,
      introAdComplete: false,
      continueCount: 0,
      continueWaiting: false
    };

    g.gameState = INTRO_STATE;
    g.score = 0;
  }
  create () {
    // console.log('Play.create');

    apiManager.trackGameStart();

    let g = this;

    let elevator = new Elevator(g);
    let barriers = new Barriers(g);
    let hero = new Hero(g);
    let health = new Health(g);
    let powerMeter = new PowerMeter(g);
    let burstParticles = new BurstParticle(g);

    let scoreText = g.add.bitmapText(config.CENTER_X, 100, 'ocr45', '0', 45);
    scoreText.setOrigin(0.5);

    if (dataManager.getHighScore() !== 0) {
      let bestText = g.add.bitmapText(config.CENTER_X, 140, 'ocr20', dataManager.getHighScore().toLocaleString(), 20);
      bestText.setOrigin(0.5);
    }

    const textStyle = { fontFamily: g.game.localis.mainFont, fontSize: 54 +"px", color: "#ffffff",
      stroke: "#000000", strokeThickness: Math.ceil(8), align: "center", wordWrap: { width: 320 } };
    const gameText = g.add.text(config.CENTER_X, config.CENTER_Y - 50, g.game.localis.GetString("ouch").toLocaleUpperCase(g.game.localis.language), textStyle);
    gameText.setOrigin(0.5);
    gameText.setVisible(false);
    gameText.setActive(false);

    // let scoreText = g.add.bitmapText(config.CENTER_X, 50, 'ocr30', '0', 30);
    // scoreText.setOrigin(0);

    let knight = new Knight(g);

    g.elevator = elevator;
    g.barriers = barriers;
    g.hero = hero;
    g.health = health;
    g.powerMeter = powerMeter;
    g.burstParticles = burstParticles;
    g.gameText = gameText;
    g.scoreText = scoreText;
    // g.bestText = bestText;
    g.knight = knight;

    elevator.setSpeed(this.speed);
    hero.scrollIn(() => {
      g.gameState = GAME_STATE;
      g.showHtp();
      // temp start the htp countdown right away
      // g.completeHtp();
      // end temp
    });

    g.events.on('resume', (scene, data) => {
      soundManager.resumeMusic();
    });

    g.input.on('pointerdown', (pointer) => {
      if (pointer.x >= config.WIDTH - 125 && pointer.y <= 125) {
        return;
      }
      if (g.gameState !== GAME_STATE) {
        return;
      }
      if (this.levelData.htpWaiting) {
        g.completeHtp();
      }
      hero.cycle();
    });

    if (g.input.keyboard) {
      g.input.keyboard.on("keydown_SPACE", (event) => {
        if (g.gameState !== GAME_STATE) {
          return;
        }
        if (this.levelData.htpWaiting) {
          g.completeHtp();
        }
        hero.cycle();
      });
    }

    let pauseBtn = g.add.sprite(config.WIDTH - 60, 60, 'hero', 'pause-btn.png');
    pauseBtn.setInteractive();
    pauseBtn.on('pointerdown', () => {
      g.scene.launch('Pause');
    });

    this.transition = new Transition(g);
    this.transition.out();

    soundManager.playMusic('loop-game-1');

    this._onWindowBlur = this.onWindowBlur.bind(this);
    this._onVisibilityChange = this.onVisibilityChange.bind(this);

    window.addEventListener("blur", this._onWindowBlur);
    document.addEventListener("visibilitychange", this._onVisibilityChange);
  }
  shutdown () {
      window.removeEventListener("blur", this._onWindowBlur);
      document.removeEventListener("visibilitychange", this._onVisibilityChange);
  }
  onVisibilityChange () {
      if (document.hidden || document.msHidden || document.webkitHidden) {
          this.onWindowBlur();
      }
  }
  onWindowBlur () {
    let g = this;
    if (g.scene.isActive(g.scene.key)) {
      g.scene.launch('Pause');
    }
  }
  startNextFloor () {
    let g = this;
    let levelData = g.levelData;
    let elevator = g.elevator;
    let barriers = g.barriers;
    let knight = g.knight;

    dataManager.addPoints(POINTS_PER_FLOOR);

    if (levelData.currentFloorPerfection) {
      levelData.perfectFloorCount++;
      if (levelData.perfectFloorCount >= dataManager.achievements.CrystalClear.hardCodeRequired) {
        dataManager.unlockAchievement(dataManager.achievements.CrystalClear);
      }
    }
    levelData.currentFloorPerfection = true;
    levelData.floor++;
    barriers.reset();
    elevator.setSpeed(this.speed);
    elevator.queueDoor();
    knight.flyOver(() => {
      g.showGameText(g.floorText, 2000, () => {
        barriers.spawn();
      });
    });

    dataManager.addAchievementProgress(dataManager.achievements.ForeverDefense, 1);
    if (levelData.floor > dataManager.achievements.RockinIt.hardCodeRequired) {
      dataManager.unlockAchievement(dataManager.achievements.RockinIt);
    }

    switch (levelData.floor) {
      case 5:
        soundManager.playMusic('loop-game-2');
        break;
      case 10:
        soundManager.playMusic('loop-game-3');
        break;
    }

    // console.log('start next floor', g.floorText);
  }
  /* PRIMARY UPDATE LOOP
  ========================================================================== */
  update (time, delta) {
    let g = this;
    let scoreText = g.scoreText;

    // START STATS - for tracking game performance (Frames Per Second)
    if (g.sys.game.stats) {
      g.sys.game.stats.begin();
    }

    // ACCURACY - Used to main consistent speeds across different devices that might have a slower fps update
    let accuracy = delta / FPS;

    switch (g.gameState) {
      case GAME_STATE:
        g.gameLoop(accuracy);
        break;
      case SPECIAL_STATE:
        g.specialLoop(accuracy);
        break;
      case TRANSITION_STATE:
        g.transitionLoop(accuracy);
        break;
    }

    let score = dataManager.getScore();
    if (g.score !== score) {
      scoreText.setText(score.toLocaleString());
      g.score = score;
    }

    // END STATS - for tracking game performance (Frames Per Second)
    if (g.sys.game.stats) {
      g.sys.game.stats.end();
    }
  }
  /* GAME STATE LOOP
  ========================================================================== */
  gameLoop (accuracy) {
    let g = this;
    let levelData = g.levelData;
    let elevator = g.elevator;
    let barriers = g.barriers;
    let powerMeter = g.powerMeter;
    let hero = g.hero;
    // CLASS UPDATE LOOPS
    elevator.update(accuracy);
    barriers.update();

    // HERO VS BARRIER LOGIC
    _.each(barriers.alive, (barrier) => {
      if (barrier.y > hero.hitY) {
        if (barrier.element === hero.activeElement) {
          barriers.burst(barrier);
          powerMeter.addPower(this.barrierBurstPower);
          if (powerMeter.isFilled) {
            g.startSpecial();
          }
        } else {
          powerMeter.drainPower(METER_BARRIER_DRAIN);
          g.mismatchCollision();
        }
      }
    });
    // END HERO VS BARRIER LOGIC

    // SPAWN LOGIC
    if (barriers.isSpawnReady && barriers.spawnCount < this.floorBarrierTotal) {
      barriers.spawn();
    }
    // END SPAWN LOGIC

    if (this.remainingBarriers === 0) {
      g.startNextFloor();
    }
  }
  /* SPECIAL STATE LOOP
  ========================================================================== */
  specialLoop (accuracy) {
    let g = this;
    let levelData = g.levelData;
    let elevator = g.elevator;
    let barriers = g.barriers;
    let powerMeter = g.powerMeter;
    let hero = g.hero;

    // CLASS UPDATE LOOPS
    elevator.update(accuracy);
    barriers.update();

    // HERO VS BARRIER LOGIC
    _.each(barriers.alive, (barrier) => {
      if (barrier.y > hero.hitY) {
        // soundManager.playSound('cannonbolt-hit');
        barriers.burst(barrier, true);
        powerMeter.setPower(g.remainingBarriers / SPECIAL_BARRIER_COUNT * 100);
      }
    });
    // END HERO VS BARRIER LOGIC

    // SPAWN LOGIC
    if (barriers.isSpawnReady && barriers.spawnCount < this.floorBarrierTotal) {
      barriers.spawn();
    }
    // END SPAWN LOGIC

    if (this.remainingBarriers === 0) {
      g.endSpecial();
    }
  }
  /* TRANSITION STATE LOOP
  ========================================================================== */
  transitionLoop (accuracy) {
    let g = this;
    let elevator = g.elevator;
    let barriers = g.barriers;

    // CLASS UPDATE LOOPS
    elevator.update(accuracy);
    barriers.update();
  }
  /* START SPECIAL
  ========================================================================== */
  startSpecial () {
    let g = this;
    let barriers = this.barriers;
    let hero = this.hero;
    let elevator = g.elevator;

    g.gameState = SPECIAL_STATE;

    barriers.fadeAll();
    barriers.reset();
    hero.startSpecial();
    elevator.setSpeed(SPECIAL_SPEED);
    elevator.start();

    g.showGameText(g.game.localis.GetString("cannonbolt_power").toLocaleUpperCase(g.game.localis.language), 2000, () => {
      barriers.spawn();
    });

    soundManager.playSound('cannonbolt');

    dataManager.unlockAchievement(dataManager.achievements.CannonboltPower);
  }
  endSpecial () {
    let g = this;
    let elevator = g.elevator;
    let hero = g.hero;

    g.gameState = TRANSITION_STATE;
    elevator.setSpeed(this.speed);

    g.time.delayedCall(1000, () => {
      hero.endSpecial(() => {
        g.gameState = GAME_STATE;
        g.startNextFloor();
      });
    });
  }
  /* MISMATCH COLLISION
  ========================================================================== */
  mismatchCollision () {
    let g = this;
    let barriers = this.barriers;
    let health = this.health;
    g.levelData.currentFloorPerfection = false;
    barriers.endBurstStreak();
    g.cameras.main.shake(250, 0.005);
    barriers.fadeAll();
    health.drain();
    soundManager.playSound('damage');
    if (health.filled === 0) {
      g.showGameOver();
      return;
    }
    g.showGameText(g.game.localis.GetString("ouch").toLocaleUpperCase(g.game.localis.language), 2000, () => {
      barriers.spawn();
    });
  }
  /* SHOW GAME TEXT
  ========================================================================== */
  showGameText (text, delay, cb) {
    let g = this;
    let gameText = g.gameText;
    gameText.setVisible(true);
    gameText.setActive(true);
    gameText.setText(text);
    gameText.setAlpha(0);
    gameText.setFontSize(54);
    MPUtils.ClampTextToDimensions(gameText, 320, 120);

    let tl = g.tweens.createTimeline();

    tl.add({
      targets: gameText,
      alpha: 1,
      duration: 100
    });
    tl.add({
      targets: gameText,
      alpha: 0,
      delay: delay,
      duration: 100,
      onComplete: () => {
        gameText.setVisible(false);
        gameText.setActive(false);
        if (cb) {
          cb();
        }
      }
    });
    tl.play();
  }
  /* SHOW HTP
  ========================================================================== */
  showHtp () {
    let g = this;

    const ipadOS = (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2);
    const mobile = !g.game.device.os.desktop || ipadOS;

    const textStyle = { fontFamily: g.game.localis.mainFont, fontSize: 25 +"px", color: "#ffffff",
      align: "center", wordWrap: { width: 320 } };
    const htpText = g.game.localis.GetString(mobile ? "how_to_play" : "how_to_play_desktop").toLocaleUpperCase(g.game.localis.language);
    const htpA = g.add.text(config.CENTER_X, config.CENTER_Y - 150, htpText, textStyle);
    htpA.setOrigin(0.5);
    htpA.setAlpha(0);
    MPUtils.ClampTextToDimensions(htpA, 320, 160);
    const subTextStyle = { fontFamily: g.game.localis.mainFont, fontSize: 44 +"px", color: "#ffffff",
      stroke: "#000000", strokeThickness: Math.ceil(8) };
    const countDownText = g.game.localis.GetString(mobile ? "tap_to_start" : "click_to_start").toLocaleUpperCase(g.game.localis.language);
    const countDown = g.add.text(config.CENTER_X, config.CENTER_Y - 50, countDownText, subTextStyle);
    countDown.setAlpha(0);
    countDown.setOrigin(0.5);
    MPUtils.ClampTextToDimensions(countDown, 320, 120);

    g.tweens.add({
      targets: [htpA, countDown],
      alpha: 1,
      duration: 300
    });

    this.htpText = { htpA, countDown };
  }
  /* COMPLETE HTP
  ========================================================================== */
  completeHtp () {
    this.levelData.htpWaiting = false;
    let g = this;
    let knight = this.knight;
    let elevator = this.elevator;
    let barriers = this.barriers;
    let { htpA, countDown } = this.htpText;

    elevator.start();

    countDown.setFontSize(44);
    countDown.setText(g.game.localis.GetString("get_ready").replace("<num>", 3).toLocaleUpperCase(g.game.localis.language));
    g.time.delayedCall(1000, () => {
      countDown.setText(g.game.localis.GetString("get_ready").replace("<num>", 2).toLocaleUpperCase(g.game.localis.language));
      g.time.delayedCall(1000, () => {
        countDown.setText(g.game.localis.GetString("get_ready").replace("<num>", 1).toLocaleUpperCase(g.game.localis.language));
        // start knight
        knight.flyOver(() => {
          g.tweens.add({
            targets: [htpA, countDown],
            alpha: 0,
            duration: 100,
            onComplete: () => {
              htpA.destroy();
              countDown.destroy();
              g.showGameText(g.floorText, 2000, () => {
                barriers.spawn();
              });
            }
          });
        });
        // end knight
      });
    });
  }
  /* SHOW AD START
  ========================================================================== */
  showStartAd () {
  }
  /* SHOW GAME OVER
  ========================================================================== */
  showGameOver () {
    let g = this;
    let hero = g.hero;
    g.gameState = TRANSITION_STATE;
    soundManager.playSound('ben-gameover');
    g.showGameText(g.game.localis.GetString("game_over").toLocaleUpperCase(g.game.localis.language), 3000, () => {
      g.transitionEndScreen();
    });
    hero.scrollOut();
  }
  /* TRANSITION TO END SCREEN
  ========================================================================== */
  transitionEndScreen () {
    let g = this;
    let barriers = this.barriers;
    dataManager.checkHighScore();
    // dataManager.addAchievementProgress(dataManager.achievements.ForeverDefense, barriers.totalBurstCount);
    dataManager.setSessionItem('lastFloor', Phaser.Utils.String.Pad(g.levelData.floor, 2, 0, 1));
    this.transition.in(() => {
      g.events.removeAllListeners('resume');
      g.scene.start('EndScore');
    });
  }
  /* GET METHODS
  ========================================================================== */
  get floorBarrierTotal () {
    let g = this;
    if (g.gameState === SPECIAL_STATE) {
      return SPECIAL_BARRIER_COUNT;
    }
    let levelData = g.levelData;
    return BARRIER_COUNT + (BARRIER_COUNT_INCREASE * levelData.floor);
  }
  get remainingBarriers () {
    let g = this;
    let barriers = this.barriers;
    let remaining = this.floorBarrierTotal - barriers.spawnCount + barriers.alive.length;
    if (remaining < 0) {
      console.warn('Negative remaining barriers, you should not get this');
    }
    return remaining;
  }
  get speed () {
    let g = this;
    let levelData = g.levelData;
    // console.log('get speed', START_SPEED + (SPEED_INCREASE * levelData.floor));
    return START_SPEED + (SPEED_INCREASE * levelData.floor);
  }
  get floorText () {
    let g = this;
    let levelData = this.levelData;
    let floorPad = Phaser.Utils.String.Pad(levelData.floor, 2, 0, 1);
    let floorText = g.game.localis.GetString("floor").replace("<num>", floorPad).toLocaleUpperCase(g.game.localis.language);
    return floorText;
  }
  get barrierBurstPower () {
    let g = this;
    let levelData = g.levelData;
    let specialCompletedCount = levelData.specialCompletedCount;
    let power = METER_BARRIER_FILL - (specialCompletedCount * METER_BARRIER_FILL_DECREASE);
    power = power > METER_BARRIER_FILL_MIN ? power : METER_BARRIER_FILL_MIN;
    return power;
  }
}

export default Play;
